<figure>
    <img *ngIf="values?.imageSrc" [alt]="values.altText" [src]="values.imageSrc" [width]="values.width" loading="lazy"
        [height]="values.height" [srcset]="values.srcSet" [sizes]="values.sizes" style="height:auto;max-width:100%;"/>
    <figcaption *ngIf="values.caption" >
        <span [innerHtml]="values.caption | markedInline"></span>
    </figcaption>
</figure>